var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-mode-dark d-md-flex d-none",on:{"click":_vm.toggleTheme}},[_c('a',{},[_c('i',{class:_vm.theme === 'dark' ? 'ti ti-toggle-left' : 'ti ti-toggle-right'}),_c('span',[_vm._v(_vm._s(_vm.theme === "dark" ? "Lights on" : "Lights off"))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }